import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteTransactionContract } from "@common/contracts/delete-transaction.contract";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const deleteTransactionContractClient = getBackendAPIClient(
    deleteTransactionContract,
);

export function markTransactionForDeletion(transactionId: number) {
    return deleteTransactionContractClient.markForDeletion({
        params: {
            transactionId,
        },
    });
}

export function finalizeTransactionDeletion(transactionId: number) {
    return deleteTransactionContractClient.finalizeDeletion({
        params: {
            transactionId,
        },
    });
}

export function useBulkMarkTransactionsForDeletion() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (transactionIds: number[]) =>
            deleteTransactionContractClient.bulkMarkForDeletion({
                body: {
                    transactionIds,
                },
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["transactions"],
            });
        },
    });
}

export function useMarkTransactionForDeletion() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: markTransactionForDeletion,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["transactions"],
            });
        },
    });
}

export function useCancelTransactionDeletion() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (transactionId: number) =>
            deleteTransactionContractClient.cancelDeletion({
                params: {
                    transactionId,
                },
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["transactions"],
            });
        },
    });
}

export function useFinalizeTransactionDeletion() {
    return useMutation({
        mutationFn: finalizeTransactionDeletion,
    });
}
